export default __webpack_public_path__ + "static/media/Enrollment.f7f47ec2.svg";